// Old Companion and brokerage addresses now redirect path-for-path to
// app.brxs.ca. These are the paths those apps used that the desk app does not
// have, mapped to where the same person should land instead of a blank page.
import { BOOK_SHOOT_URL } from "./navConfig";

export const LEGACY_PATHS = ["/book", "/register", "/job/:id", "/inbox", "/disputes/:id"];

// Returns { external: url } for off-app targets or { to: path } for in-app ones.
export function legacyTarget(pathname, search = "") {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  if (p === "/book") return { external: BOOK_SHOOT_URL + (search || "") };
  if (p === "/register") return { to: "/login?mode=register" };
  if (p === "/inbox" || /^\/job\/[^/]+$/.test(p) || /^\/disputes\/[^/]+$/.test(p)) return { to: "/" };
  return null;
}
